import { useAuth } from "@/context/AuthContext";
import { Button, etSyd } from "@/sentinel";

const APP_VERSION = process.env.REACT_APP_VERSION || "3.0.0";

/** "Print or save as PDF" plus the print-only header and footer for audit copies. Prints on Paper. */
export function PrintBar({ title, testId = "print-btn" }) {
  const { user, selectedDate } = useAuth();
  const now = new Date();
  return (
    <>
      <div className="no-print" style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button size="sm" variant="ghost" icon="Printer" onClick={() => window.print()} data-testid={testId} title="Print or save as PDF for the audit file">
          Print or save as PDF
        </Button>
      </div>
      <div className="print-only" style={{ borderBottom: "1.5px solid var(--text-primary)", paddingBottom: 6, marginBottom: 10 }}>
        <div style={{ fontSize: 18, lineHeight: "24px", fontWeight: 600 }}>Sentinel — {title}</div>
        <div className="sn-small sn-muted">
          Session <span className="sn-num">{selectedDate}</span> · audit copy · exported by {user?.email || "—"} at <span className="sn-num">{etSyd(now)}</span> · Sentinel v{APP_VERSION}
        </div>
        <div className="sn-micro" style={{ marginTop: 4 }}>Not financial advice · Not an offer to buy or sell securities · No orders are placed by this system</div>
      </div>
      <div className="print-only print-footer" data-testid="print-footer">
        Printed {etSyd(now)} by {user?.email || "—"} · append-only record; recalculations are appended as siblings, originals are never edited.
      </div>
    </>
  );
}
